import React, { FC } from 'react';

import AllocatorBlocklistToggleModal from './AllocatorBlocklistToggleModal/AllocatorBlocklistToggleModal';
import AboutIntroRequestsModal from 'buyside/components/presentation/FundProfileShowPage/FundProfileAdminDashboard/AboutIntroRequestsModal/aboutIntroRequestsModal';
import GetIntroRequestsModal from './GetIntroRequestsModal/getIntroRequestsModal';
import GetIntroducedModal from './GetIntroducedModal/getIntroducedModal';

import { formatDate } from 'buyside/util/dateHelper';

import { AllocatorProfileShowPageQuery } from 'interfaces/graphql-typings';

import styles from './allocatorProfileFundAdminDashboardStyles.scss';

const AllocatorProfileFundAdminDashboard: FC<{
  adminFunds: NonNullable<AllocatorProfileShowPageQuery['currentUser']>['adminFunds'];
  allocatorProfileId: string;
  allocatorRecentlyJoined: boolean;
}> = ({ adminFunds, allocatorProfileId, allocatorRecentlyJoined }) => {
  return (
    <div className={styles.dashboard}>
      <h4 className={styles.dashboardTitle}>Contact This Allocator</h4>
      <div className={styles.dashboardSection}>
        <div className={styles.dashboardActions}>
          <GetIntroRequestsModal />
          <AboutIntroRequestsModal />
          {adminFunds.map(({ employer }) =>
            employer?.employerProfile ? (
              <AllocatorBlocklistToggleModal
                key={`blocklist-toggle-${employer.id}`}
                allocatorProfileId={allocatorProfileId}
                fundName={employer.name}
                fundProfileId={employer.employerProfile.id}
                isBlocklisted={employer.employerProfile.isAllocatorBlocklisted}
              />
            ) : null
          )}
        </div>
      </div>
      {allocatorRecentlyJoined && (
        <p>
          You will be able to request an introduction after this allocator has been on the platform
          for 48 hours.
        </p>
      )}
      <div className={styles.dashboardSection}>
        <GetIntroducedModal
          adminFunds={adminFunds}
          allocatorProfileId={allocatorProfileId}
          disabled={allocatorRecentlyJoined}
        />
        {adminFunds.map(employerHistory => {
          const employer = employerHistory?.employer;
          const fundProfile = employerHistory?.employer?.employerProfile;
          if (!employer || !fundProfile) return null;

          return (
            <p key={employerHistory.id}>
              {employer.name} has <strong>{fundProfile.introRequestsLeft || 0}</strong>
              &nbsp;introduction request
              {fundProfile.introRequestsLeft === 1 ? '' : 's'}
              &nbsp;remaining
              {fundProfile.introRequestPeriodEnd
                ? ` until ${formatDate(fundProfile.introRequestPeriodEnd)}`
                : ''}
              .
            </p>
          );
        })}
      </div>
    </div>
  );
};

export default AllocatorProfileFundAdminDashboard;
